export default function ConinerHead ({num, select, onClick}) {

    let name;
    if (num === 1) {
        name = 'טיסה הלוך';
    } else if (num === 2) {
        name = 'טיסה חזור';
    } else if (num === 3) {
        name = 'נ"פ הלוך';
    } else if (num === 4) {
        name = 'נ"פ חזור';
    }

    const style = {
        'color' : select ? 'green' : 'red'
    }

    return (
        <div onClick={() => onClick(num)} >
            <p> {name} </p>
            <p> {select ? select : 'בחירה'} </p>
        </div>
    )
}